/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, BoxView } from '@components/atoms'
import { Grid, couponColumns } from '@grid'
import {
	useAppSelector,
	useAppDispatch,
	couponActions,
	ApiGetDataStatus,
} from '@redux/index'
import { CouponType } from '@schemas'
import { GridRowModel, GridRenderCellParams } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const CouponPage = () => {
	const reduxDispatch = useAppDispatch()
	const navigate = useNavigate()

	// redux state
	const couponList: CouponType[] = useAppSelector(state => state.coupon.couponList)
	const status: ApiGetDataStatus = useAppSelector(state => state.coupon.couponListStatus)

	const onAction = (iudFlag: string, aRow: GridRowModel) => {
		const newData = {
			iudFlag: iudFlag as 'I' | 'U' | 'D',
			couponId: aRow.id,
			name: aRow.name,
			email: aRow.email,
			code: aRow.code,
			discountUsd: aRow.discountUsd,
			discountKrw: aRow.discountKrw,
			quantity: aRow.quantity,
			expiredAt: dayjs(aRow.expiredAt).format('YYYY-MM-DD'),
			useYn: aRow.useYn,
			unitUsd: aRow.unitUsd,
			unitKrw: aRow.unitKrw,
		}
		reduxDispatch(couponActions.UPDATE_COUPON({ ...newData }))
	}

	return (
		<View css={style}>
			<BoxView title="쿠폰 관리">
				<Grid
					title="쿠폰 관리"
					rows={couponList}
					columns={couponColumns}
					loading={status === 'loading'}
					onAction={onAction}
					renderCell={
						{
							// Add any custom cell rendering if needed
						}
					}
					renderEditCell={
						{
							// Add any custom edit cell rendering if needed
						}
					}
				/>
			</BoxView>
		</View>
	)
}

export default CouponPage

// 높이 체인 — 그리드가 남은 화면을 다 받고 페이지는 스크롤하지 않는다(오더 관리와 같게, 2026-09-27)
const style = css({ height: '100%' })
